import { render } from "./EditeFicheInventairePage.vue?vue&type=template&id=57e40ec7&ts=true"
import script from "./EditeFicheInventairePage.vue?vue&type=script&lang=ts"
export * from "./EditeFicheInventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__